'use strict';

var React = require('react');

function mirror(o) {
  return o;
}

module.exports = function mapSelf(children) {
  // return ReactFragment
  return React.Children.map(children, mirror);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-calendar/~/rc-util/lib/Children/mapSelf.js
 ** module id = 219
 ** module chunks = 0
 **/